
export class LeaderboardConstants {
    static readonly globalLeaderboardUrl = ''
    static readonly maximumLeaderboardAPIRankingRangeLimit = 100
    static readonly emptyUsernameSearch = ''
    static readonly emptyRank = '-'
}
